import { SegmentedControl, Select } from '@cinesend/ui-kit'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../disabled_tooltip'
import IsMultiSelect from './is_multi_select'

const SelectCollection = ({ schema, field, saveField }) => {
  const [collectionID, setCollectionID] = useState(field.collection_id)
  const [showCollections, setShowCollections] = useState(!field.use_languages)
  const { data: collections, isLoading } = useQuery([`collections?schemaID=${schema.id}`])
  const options = collections
    ? collections.map((collection) => ({ value: String(collection.id), label: collection.name }))
    : []
  const isLocked = field?.uneditable_when_locked_attributes?.includes('use_languages') ?? false
  const updateField = (collectionID) => {
    setCollectionID(collectionID)

    if (collectionID) {
      saveField({ collection_id: collectionID, use_languages: false })
    } else {
      saveField({ collection_id: null, use_languages: true })
    }
  }
  const lockedReason = isLocked ? DISABLED_REASONS.schemaLocked : null

  return (
    <div className='space-y-4'>
      <DisabledTooltip reason={lockedReason} className='block w-full'>
        <SegmentedControl
          label='List type'
          options={[
            { label: 'Custom List', value: 'list', disabled: isLocked },
            { label: 'Language List', value: 'language', disabled: isLocked },
          ]}
          value={!showCollections ? 'language' : 'list'}
          onValueChange={(opt) => {
            if (opt === 'language') {
              updateField(null)
              setShowCollections(false)
            } else {
              setShowCollections(true)
            }
          }}
        />
      </DisabledTooltip>
      {showCollections && (
        <DisabledTooltip reason={lockedReason} className='block w-full'>
          <Select
            fullWidth
            label='List'
            options={options}
            disabled={isLocked || isLoading}
            value={collectionID ? String(collectionID) : null}
            onValueChange={(id) => updateField(Number(id))}
          />
        </DisabledTooltip>
      )}
      <IsMultiSelect field={field} saveField={saveField} />
    </div>
  )
}

export default SelectCollection
